import bsw from './img/bsw.png';
// import betradar from './img/betradar.png';
import pragmatic from './img/pragmatic.png';
import evoplay from './img/evoplay.png';
// import inbet from './img/inbet.png';
import fiable from './img/fiable.png';
import evolution from './img/evolution.png';
import tvBet from './img/tvBet.png';
import outcome from './img/outcome.png';
import slotegrator from './img/slotegrator.png';
import softgaming from './img/softgaming.png';
// import upgaming from './img/upgaming.png';
import habanero from './img/habanero.png';
import xpg from './img/xpg.png';

export const itemsOnPage = 10;

export const providerItems = [
  { value: 'all', name: 'All providers', active: true },
  // { value: 'BSWGAMES', name: 'Bsw', active: false, icon: bsw },
  { value: 'PRAGMATIC', name: 'Pragmatic', active: false },
  { value: 'OUTCOME', name: 'Outcomebet', active: false },
  { value: 'EVOPLAY', name: 'Evoplay', active: false },
  { value: 'EVOLUTION', name: 'Evolution', active: false },
  { value: 'TVBET', name: 'TVBet', active: false },
  { value: 'FIABLE', name: 'Fiable', active: false },
  { value: 'GOLDEN_RACE', name: 'Golden Race', active: false },
  { value: 'DIGITAIN', name: 'Digitain', active: false },
  { value: 'HABANERO', name: 'Habanero', active: false },
  { value: 'SLOTEGRATOR', name: 'Slotegrator', active: false },
  { value: 'CASIMI', name: 'Casimi', active: false },
  { value: 'SOFTGAMING-SLOTS', name: 'Softgaming', active: false },
  { value: 'XPG', name: 'Xpg', active: false },
  // { value: 'BETRADAR', name: 'Betradar', active: false, icon: betradar },
  // { value: 'INBET', name: 'Inbet', active: false, icon: inbet },
  // { value: 'SOFTGAMING', name: 'Softgaming', active: false, icon: softgaming },
  // { value: 'UPGAMING', name: 'UPGAMING', active: false, icon: upgaming },
  /* { value: 'EZUGI', name: 'Ezugi', active: false, icon: ezugi }, */
];
export const gameTypeItems = [
  { value: 'all', name: 'all', active: true },
  { value: 'slots', name: 'casino', active: false },
  { value: 'live-casino', name: 'liveCasino', active: false },
  /* { value: 'fiable', name: 'crashGames', active: false }, */
];
export const statusItems = [
  /* { value: 0, name: 'all', active: true }, */
  { value: 1, name: 'win', active: false },
  { value: 2, name: 'lose', active: false },
];
